const axios = require('axios').default;

export const sendData = async (formData, e) => {
  try {
    const response = await axios.post(`https://now-api.vodacom.co.za/api/v1/newsletter-subscription`, formData);
    const data = await response;
  } catch (err) {
      console.log(err.response);
  }
};